import _ from 'lodash'
import apis from '@/apis'
import Constants from '@/constants'
import Util from '@/util'
import * as axios from 'axios'

const FileHandler = {
  async upload (path = 'upload/create', formData, data, callbackUpload) {
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Accept': 'application/json'
      },
      onUploadProgress: async function (progressEvent) {
        if (callbackUpload && typeof callbackUpload === 'function') {
          await callbackUpload(progressEvent, data && data.uid)
        }
      }
    }
    if (formData && data && !_.isEmpty(data)) {
      for (let key in data) {
        formData.append(key, data[key])
      }
    }
    // for (var pair of formData.entries()) {
    //   console.log('--> ' + pair[0] + ', ' + pair[1])
    // }
    // https://irisdev.adaptconcepts.com/iris-server/public/api/upload/create
    let response = await apis.post(`${Constants.BASE_API}${path}`, formData, config)
    return response
    // ).then(x => x.data
    // ).then(data => {
    //   // console.log('-- uploading.. --')
    //   // console.log(data)
    //   var index = 0
    //   for (var pair of formData.entries()) {
    //     // console.log('-- part --')
    //     // console.log(pair[0])
    //     // console.log(pair[1])
    //     if (data.files && index < data.files.length) {
    //       data.files[index].file = pair[1]
    //     }
    //     index += 1
    //   }
    //   resolve(data)
    // }).catch(error => reject(error))
  },

  getFileTypes () {
    return [
      'jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'tif', 'svg', 'webp',
      'midi', 'mid', 'aac', 'mp3', 'wav', 'oga', 'weba',
      'avi', 'mpeg', '3gp', '3g2', 'ogv', 'webm',
      'txt', 'rtf', 'csv', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'
    ]
  },

  getMimeFileTypes () {
    let types = FileHandler.getFileTypes()
    let info = {}
    for (let t in types) {
      let type = types[t]
      let mime = FileHandler.getMime(type)
      if (!info.hasOwnProperty(mime)) {
        info[mime] = []
      }
      info[mime].push(type)
    }
    return info
  },

  getMime (extension) {
    switch (extension.toLowerCase()) {
      // image
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg'
      case 'png':
        return 'image/png'
      case 'gif':
        return 'image/gif'
      case 'bmp':
        return 'image/bmp'
      case 'tiff':
      case 'tif':
        return 'image/tiff'
      case 'svg':
        return 'image/svg+xml'
      case 'webp':
        return 'image/webp'
      // audio
      case 'midi':
      case 'mid':
        return 'audio/midi'
      case 'aac':
        return 'audio/aac'
      case 'mp3':
        return 'audio/mpeg'
      case 'wav':
        return 'audio/wav'
      case 'oga':
        return 'audio/ogg'
      case 'weba':
        return 'audio/webm'
      // video
      case 'avi':
        return 'video/x-msvideo'
      case 'mpeg':
        return 'video/mpeg'
      case '3gp':
        return 'video/3gpp'
      case '3g2':
        return 'video/3gpp2'
      case 'ogv':
        return 'video/ogg'
      case 'webm':
        return 'video/webm'
      // doc
      case 'txt':
        return 'text/plain'
      case 'rtf':
        return 'application/rtf'
      case 'csv':
        return 'text/csv'
      case 'pdf':
        return 'application/pdf'
      case 'doc':
        return 'application/msword'
      case 'docx':
        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      case 'xls':
        return 'application/vnd.ms-excel'
      case 'xlsx':
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      case 'xlsm':
        return 'application/vnd.ms-excel.sheet.macroEnabled.12'
      case 'ppt':
        return 'application/vnd.ms-powerpoint'
      case 'pptx':
        return 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
      // archive
      case 'zip':
        return 'application/zip'
      case 'rar':
        return 'application/vnd.rar'
      case '7z':
        return 'application/x-7z-compressed'
      default:
        throw new Error(`invalid handled mime extension: ${extension}`)
    }
  },

  getPathExt (url) {
    // eslint-disable-next-line no-useless-escape
    return url.split('.').pop().split(/\#|\?/)[0]
  },

  getPathFilename (url) {
    // eslint-disable-next-line no-useless-escape
    return url.split('/').pop().split(/\#|\?/)[0]
  },

  async download (url) {
    // return axios.request({
    //   url,
    //   method: 'GET',
    //   responseType: 'blob'
    // }).then(response => {
    //   const downloadUrl = window.URL.createObjectURL(new Blob([response.data]))
    //   const link = document.createElement('a')
    //   link.href = downloadUrl
    //   link.setAttribute('download', 'file.jpeg')
    //   document.body.appendChild(link)
    //   link.click()
    //   link.remove()
    // })
    // let config = {
    //   // crossdomain: true,
    //   // headers: {
    //   //   // 'Content-Type': 'multipart/form-data',
    //   //   // 'Accept': 'application/json'
    //   // },
    //   // responseType: 'blob'
    //   headers: {
    //     'Accept': '*/*',
    //     'Access-Control-Allow-Origin': '*',
    //     'Content-Type': 'image/jpeg',
    //     'x-amz-acl': 'public-read'
    //     // 'Access-Control-Allow-Methods': 'GET, HEAD, POST',
    //     // 'Access-Control-Max-Age': 10000
    //   }
    // }
    try {
      // console.log('--download 1')
      let ext = FileHandler.getPathExt(url)
      let type = FileHandler.getMime(ext)
      if (!ext || ext.length <= 0 || !type || type.length <= 0) {
        throw new Error(`invalid extension or mime type: ${ext}/${type}`)
      }
      // console.log('-- file type: ' + ext, type)
      let config = {
        headers: {
          'Accept': type
        },
        responseType: 'blob'
      }
      if (/* type.indexOf('image') >= 0 */url.indexOf('http://') >= 0 || url.indexOf('https://') >= 0) {
        url += `?d=${Util.string.random()}`
      }
      // console.log('--download 2')
      let response = await axios.get(url, config)
      if (!response) {
        throw new Error('invalid response')
      }
      // console.log('--download 3')
      const blob = new Blob([response.data], { type })
      const link = document.createElement('a')
      link.crossOrigin = 'anonymous' // CORS fix 1 *
      link.href = URL.createObjectURL(blob)
      link.download = FileHandler.getPathFilename(url) || `download.${ext}`
      link.click()
      URL.revokeObjectURL(link.href)
      // console.log('--download 4')
    } catch (error) {
      window.open(url, '_blank')
      throw error
    }
  }
}

export default FileHandler
